import angular from 'angular';
import {fields} from './fields.js';
import swal from 'sweetalert';

class FormController {
    constructor(Model) {
        this.Model = Model;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            swal("", "Podaci su uspiješno pohranjeni", "success");
            this.onSubmit({model: data});
        });
    }

    cancel() {
        if (this.form.$pristine) {
            this.onCancel();
            return;
        }
        swal({
            title: "Jeste li sigurni?",
            text: "Podaci nisu spremljeni. Želite li zatvoriti formu za unos?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Da, zatvori!",
            cancelButtonText: 'Odustani',
            closeOnConfirm: true
        },
        () => this.onCancel());
    }

    getFields(){
        return [
            {
                wrapper:'row',
                fieldGroup: [
                    {
                        wrapper: 'div',
                        templateOptions: {
                            className: 'col-md-6'
                        },
                        fieldGroup: [
                            fields.djelatnost,
                            fields.datum
                        ]
                    },
                    {
                        wrapper: 'div',
                        templateOptions: {
                            className: 'col-md-6'
                        },
                        fieldGroup:[
                            fields.operacija
                        ]
                    },
                ]
            },
            {
                wrapper: 'row',
                fieldGroup: [
                    {
                        wrapper: 'fieldset',
                        templateOptions: {
                            label: 'Osoblje',
                            className: 'col-md-6'
                        },
                        fieldGroup: [
                            fields.operater,
                            fields.anesteziolog,
                            fields.anestezioloski_tehnicar,
                            fields.asistent_1,
                            fields.asistent_2,
                            fields.instrumentarka
                        ]
                    },

                    {
                        wrapper: 'row',
                        className: 'col-md-6',
                        fieldGroup: [
                            {
                                wrapper: 'fieldset',
                                templateOptions: {
                                    label: 'Dijagnostički podaci',
                                    className: 'col-md-12'
                                },
                                fieldGroup: [
                                    fields.dijagnoza,
                                    fields.dijagnoza_text
                                ]
                            },

                            {
                                wrapper: 'fieldset',
                                templateOptions: {
                                    // label: 'Anestezija',
                                    className: 'col-md-12'
                                },
                                fieldGroup: [
                                    fields.anestezija
                                ]
                            }
                        ]
                    }



                ]

            },
            {
                wrapper:'fieldset',
                templateOptions: {
                    label: 'Operacija'
                },
                fieldGroup: [
                    fields.napomena
                ]
            }

        ];
    }
}

FormController.$inject = ['Nalaz'];

export default FormController;



// WEBPACK FOOTER //
// ./app/components/nalaz/form/form.controller.js